import React, { useEffect, useState } from "react";

interface DatepickerProps {
  date: string;
  setDate: (newDate: string) => void;
  disabled: boolean;
  minDate?: string;
  type: "DATE_MIN" | "DATE_MAX";
  startDate?: string;
  className?: string;
}

const Datepicker: React.FC<DatepickerProps> = ({
  date,
  setDate,
  disabled,
  minDate,
  type,
  startDate,
  className = "w-full",
}) => {
  const [calculatedMinDate, setCalculatedMinDate] = useState<string | undefined>(minDate);

  useEffect(() => {
    if (type === "DATE_MAX" && startDate) {
      setCalculatedMinDate(startDate); // Ensure end date cannot be before start date
    } else if (minDate) {
      setCalculatedMinDate(minDate);
    }
  }, [startDate, type, minDate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value); // Directly store in YYYY-MM-DD format
  };

  return (
    <div className={`relative ${className}`}>
      <input
        type="date"
        className="bg-white border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-[8px]"
        value={date} // Ensure value is always YYYY-MM-DD
        onChange={handleChange}
        disabled={disabled}
        min={calculatedMinDate || minDate} // Dynamically set the minimum date
      />
    </div>
  );
};

export default Datepicker;
